import Medico from '../../../../images/dashboard/Medico.svg';
import { Box, Button, Flex, Image, chakra, Skeleton } from '@chakra-ui/react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
function CardEspecialidadesNaoAssinantes() {
  const [imgLoaded, setImgLoaded] = useState(false);
  const navigate = useNavigate();
  return (
    <Box display="flex" justifyContent="center" alignItems="center" w="100%">
      <Box alignContent={'center'} justifyContent={'center'} w="96%" maxW="480px" p={6} borderRadius="xl" bg="#5AB2AE" position="relative" overflow="hidden" maxH={300} mt={-5}>
        <Flex align="center" justify="space-between" gap={6} position="relative">
          <Box flex="1" maxW="300px">
            <chakra.h1 color="white" fontWeight="bold" fontSize="xl" mb={2}>
              A melhor telemedicina <br /> do Brasil!
            </chakra.h1>

            <chakra.h2 color="white" fontWeight="medium" fontSize="md" mb={4} lineHeight="1.4">
              Clínico Geral, Pediatria 24h e +12 especialidades online
            </chakra.h2>

            <Button
              bg="white"
              color="#5AB2AE"
              borderRadius="full"
              px={5}
              py={2}
              rightIcon={<span>→</span>}
              fontWeight="bold"
              onClick={() => {
                navigate('/cadastro/plano', { state: { telemedicina: true } });
              }}
            >
              Ver Planos
            </Button>
          </Box>

          <Box flexShrink={0} position="relative" zIndex={2}>
            <Skeleton isLoaded={imgLoaded} borderRadius="lg" w="140px" h="140px">
              <Image
                src={Medico}
                alt="Médica"
                borderRadius="lg"
                w="140px"
                h="auto"
                objectFit="cover"
                boxShadow="md"
                onLoad={() => setImgLoaded(true)}
              />
            </Skeleton>
            <Box position="absolute" left="-60px" bottom="-60px" w="200px" h="200px" bg="rgba(255, 255, 255, 0.15)" borderRadius="50%" zIndex={1} />
          </Box>
        </Flex>
      </Box>
    </Box>
  );
}

export default CardEspecialidadesNaoAssinantes;
